class WebhookForm extends HTMLElement {
  constructor() {
    super();
    this.addWebhook = this.addWebhook.bind(this);
    this.removeWebhook = this.removeWebhook.bind(this);
  }

  connectedCallback(){
    let action_id = this.getAttribute("data-action-id");
    let timing = this.getAttribute("data-action-timing");
    this.innerHTML = `<div class="row" style="margin-bottom:5px; position:relative;">
          <div class="col-md-4">
            <select is=webhook-select class="form-control action_id" data-selected=${action_id}></select>
          </div>
          <div class="col-md-6">
            <select class="form-control action_timing">
              <option value="1" ${timing == "1" ? "selected":""}>Beginning of Call</option>
              <option value="8" ${timing == "8" ? "selected":""}>End of Call</option>
            </select>
          </div>
          <div class="col-md-2" style="line-height:30px;">
            <a class="remove_webhook"><span class="fa fa-minus"></span></a>
            <a class="add_webhook"><span class="fa fa-plus"></span></a>
          </div>`;
    this.querySelector(".add_webhook").addEventListener("click", this.addWebhook)
    this.querySelector(".remove_webhook").addEventListener("click", this.removeWebhook.bind(this))
  }

  getValue() {
    if(this.querySelector(".action_id").value != "null") {
      return { action_id: this.querySelector(".action_id").value, action_timing: this.querySelector(".action_timing").value }
    } else {
      return null;
    }
  }

  addWebhook() {
    let webhookForm = new WebhookForm();
    this.closest(".campaign_webhooks_container").appendChild(webhookForm);
  }

  removeWebhook() {
    this.closest(".campaign_webhooks_container").removeChild(this)
  }
}

customElements.define('webhook-form', WebhookForm);

